export default __webpack_public_path__ + "static/media/pop.6156806d.png";